import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-orders-reports-nb-articles-card',
  templateUrl: './orders-reports-nb-articles-card.component.html',
  styleUrls: ['./orders-reports-nb-articles-card.component.scss']
})
export class OrdersReportsNbArticlesCardComponent implements OnInit {

  @Input() value;

  constructor() { }

  ngOnInit() {
  }

}
